module.exports = __webpack_public_path__ + "montserrat-semibolditalic-webfont.d66d44011c98515344a3.woff2";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/fonts/montserrat-semibolditalic-webfont.woff2
// module id = ../../../../../src/assets/fonts/montserrat-semibolditalic-webfont.woff2
// module chunks = styles